---
title: My tasks
summary: "The task list shows the steps waiting for a person, yours and your seat's, grouped by when they are due."
visibility: authenticated
feature: process_engine
audience: end-user
section: Pages
order: 20
last_verified: 2026-10-20
owner: docs
routes: ['/tasks']
aliases: [to-do list, todo, my work, work list, work queue, assignments, what is waiting for me]
tour:
  - anchor: tasks.header.scope
    text: "Choose whose tasks to list. mine is yours, seat is every task your seat can work, all is every task you may see."
  - anchor: tasks.list.groups
    text: "Tasks are grouped by when they are due, overdue first. Open a row to work the step."
  - anchor: tasks.list.groups
    text: "A row marked wait is a step that ends when something happens on the record, such as a recorded result."
---

# My tasks

A process (for example the charter quote) moves through steps, and a step worked by a
person opens a task. The task list is where those tasks wait. Open it from **Tasks**
in the sidebar, or from the **My work** card on Home.

## Whose tasks

The switch at the top chooses the list:

- **mine**: tasks assigned to you, and the ones you claimed.
- **seat**: every open task of a seat you hold (Commercial, Dispatch and so on), claimed or not.
- **all**: every task you may see, when your role allows it.

A seat is a role in the process; who holds it is set by an admin on the Roles page.
You see a task only when you hold its seat, or it is assigned to you.

## Reading a row

Each row names the step (its number and title), the record it belongs to and when it
is due. Rows are grouped by when they are due, overdue first. Press a row to open the
task page, where you work the step: see [A task page](/help/pages/task).

A row with the **wait** badge is not a form. It ends when something is recorded on the
record (a feasibility result, a sent quote, the customer's answer), and opening it
takes you to the place on the record where you record it.
